import React, { useEffect, useState, useRef } from 'react';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Modal from 'react-bootstrap/Modal';
import PulseLoader from "react-spinners/PulseLoader";
import { useNavigate } from "react-router-dom";
import $ from 'jquery';
import { BackToKdealerLogin, RemoveCookie, days, user_session_id, GetDomain, GetCoockie } from '../GlobalScript'
import FooterSmall from '../FooterSmall';
import Cookies from 'js-cookie';

export default function Login() {
    const navigate = useNavigate();
    const [UserInfo, setUserInfo] = useState(null);
    const [login, setLogin] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [Loading, setLoading] = useState(true);
    const [LoginError, setLoginError] = useState('');

    const handleChange = (event) => {
        const { name, value } = event.target;
        if (name === 'email') {
            setEmail(value);
        } else if (name === 'password') {
            setPassword(value);
        }
    };
    const signin = async () => {
        if (!email || !password || email.trim() === '' || password === '') {
            return;
        }
        try {
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify({ label: email, value: password })
            };

            const res = await fetch('kdealer/SignIn', requestOptions);

            if (res.status !== 200) {
                const msg = "Incorrect email or password.";
                setLoginError(msg);
                throw new Error(msg);
            }
            const usrSession = await res.json();

            const userObj = {
                'firstName': usrSession.firstName,
                'lastName': usrSession.lastName,
                'email': usrSession.email,
                'dealerKey': usrSession.dealerKey,
                'userKey': usrSession.userKey,
                'dealerName': usrSession.dealerName,
                'dealerID': usrSession.dealerID,
                'loginType': usrSession.loginType,
                'region': usrSession.region,
                'address': usrSession.address,
                'loading': 0
            };
            let domain = GetDomain();
            console.log('domain: ' + domain);
            if (domain === '') {
                Cookies.set('user', JSON.stringify(userObj), { expires: days });
            }
            else {
                Cookies.set('user', JSON.stringify(userObj), { expires: days, domain: domain, secure: true });
            }
            setUserInfo({
                'firstName': usrSession.firstName,
                'lastName': usrSession.lastName,
                'email': usrSession.email,
                'dealerKey': usrSession.dealerKey,
                'userKey': usrSession.userKey,
                'loginType': usrSession.loginType,
                'kmcst': usrSession.KMCST,
                'dealerID': usrSession.dealerID,
                'rdmString': 'testtest'
            });
            localStorage.clear();
            window.GlobalLoading = 0;
            console.log('cookie: ' + GetCoockie());
            if (usrSession.loginType === 1) {
                navigate('/dealerhome');
            }
            else if (usrSession.loginType === 5) {
                navigate('/kcountrieshome');
            }
                     
        }
        catch (e) {

        }
        
    }
    const handleSignin = () => {
        signin();
    };
    useEffect(() => {
        if (Loading) {
            debugger;
            console.log(window.location.href);
            RemoveCookie(days, user_session_id);
            setLoading(false);
        }
    }, [Loading])

    useEffect(() => {
        console.log(email)
    }, [email])

    return (
        <>
            <div className="login-bg"></div>
            <Container className="main-container">
                <Row className="margin-vertical">

                    <Col lg={5} className="login-card card">
                        <Row className="green-border-bottom black-bg">
                            <Col sm={12}>
                                <h1>KAWASAKI DEALERS <br /> PARTS ACCESSORIES</h1>
                            </Col>
                        </Row>

                        <Row>
                            {!login ?
                            <>
                                <Col sm={12}>
                                    <h3>DEALERS</h3>
                                    <p>This website is accessible for authorized Dealers only.</p>
                                </Col>
                                <Col sm={12} className="text-center">
                                        {/*<Button variant="secondary" onClick={e => { navigate('/dealerhome?id=41ad50c3f26543b29dc7') }}>*/}
                                        <Button variant="secondary" onClick={BackToKdealerLogin}>
                                        <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                                            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                        </svg>
                                        LOGIN
                                    </Button>
                                </Col>
                            </>
                            :
                            <>
                                <Col>
                                    <h3>DEALERS</h3>
                                </Col>
                                <Col className="text-right">
                                        <p className="underline" onClick={ e => {setLogin(false)} }>Dealers Login</p>
                                </Col>
                            </>
                            }
                        </Row>

                        <Row className="gray-bg">
                            <Col sm={12}>
                                <h3>OTHER USERS</h3>
                                {!login ? 
                                    <p>For all other users <span className="underline" onClick={ e => {setLogin(true)} }>click here</span> to login or request access to the site.</p>
                                :
                                <>
                                    <p>Required Fields*</p>

                                    <FloatingLabel controlId="floatingEmail" label="Email Address*" className="mb-3">
                                        <Form.Control type="email" placeholder="name@example.com" onChange={handleChange} value={email} name="email" className={`form-control`} />
                                    </FloatingLabel>

                                    <FloatingLabel controlId="floatingPassword" label="Password*" className="mb-3">
                                        <Form.Control type="password" placeholder="password" onChange={handleChange} value={password} name="password" className={`form-control`} />
                                    </FloatingLabel>
                                        {LoginError}
                                    <div className="text-right m-t-md">
                                            <Button variant="secondary" onClick={() => handleSignin()}>
                                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                            </svg>
                                            SIGN IN
                                        </Button>

                                        <p className="m-t-sm underline">Forgot Password?</p>
                                    </div>
                                </>
                                }

                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
            <FooterSmall />
        </>
    );
}